import { registerPopupActivity } from '../../registry'

// 模块加载时即触发图片懒加载，不阻塞渲染
// 弹窗出现前（需登录 + 队列等待）图片已大概率缓存完毕
import { getUnreadEvent, readEvent } from './api'
import { customLocalStorage } from '@/tool/storage'
import { isEnteredFromInstalledWebApp } from '@/tool/pwaEntry'
import Tga from '@/tool/ta'

registerPopupActivity({
  id: 'bonus-reward',
  priority: 100,
  blockers: ['cookie', 'payment', 'payResult'],

  async init({ popupQueue, store, showPopup }) {
    try {
      const userState = store.state.user
      const res = await getUnreadEvent({
        game_id: process.env.VUE_APP_GAME_ID,
        role_id: userState.userInfo.role_id,
        real_role_id: userState.userInfo.real_role_id,
        channel_from: customLocalStorage.getItem('dd_channel') || 'organic',
        from_desktop_app: isEnteredFromInstalledWebApp() ? 1 : 0,
        login_type: store.state.user.loginType,
        tga_os: Tga.ta.getPresetProperties().toEventPresetProperties()['#os'],
      })

      if (res.data && res.data.code === 1) {
        const events = res.data.data.unread_event || []
        // event_type 1 = 大额礼包加赠弹窗
        const bonusEvents = events.filter((e) => e.event_type === 1)
        console.log('bonusEvents======', bonusEvents)
        if (bonusEvents.length) {
          popupQueue.enqueue({
            id: 'bonus-reward',
            priority: 100,
            blockers: ['cookie', 'payment', 'payResult'],
            show: () => showPopup('bonus-reward', { events: bonusEvents }),
          })
        }
      }
    } catch (e) {
      // 活动接口失败不影响主流程
      console.warn('[bonus-reward] init failed:', e)
    }
  },
})

/**
 * 上报事件已读
 * @param {string[]} eventIds - 要标记已读的事件 ID 列表
 */
export async function reportEventsRead(eventIds, store) {
  const userState = store.state.user
  for (const eventId of eventIds) {
    try {
      await readEvent({
        game_id: process.env.VUE_APP_GAME_ID,
        role_id: userState.userInfo.role_id,
        real_role_id: userState.userInfo.real_role_id,
        event_id: eventId,
      })
    } catch (e) {
      console.warn('[bonus-reward] readEvent failed:', e)
    }
  }
}
